import React from 'react';
import { Container, CardDeck, Card } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCut } from '@fortawesome/free-solid-svg-icons';

import './ServicesPage.css';

import womenscutting_image from '../../../static/images/pages/services/womenscutting.png';
import menscutting_image from '../../../static/images/pages/services/menscutting.png';
import updostyles_image from '../../../static/images/pages/services/updostyles.png';
import styling_image from '../../../static/images/pages/services/styling.png';
import coloring_image from '../../../static/images/pages/services/coloring.png';
import hairtreatment_image from '../../../static/images/pages/services/hairtreatment.png';

// import test_image from '../../../static/images/test_image.jpg';

const ServicesPage = () => {
  return (
    <div className="services-page">
      <Container>
        {/* Page Title */}
        <h2>
          <FontAwesomeIcon className="page-title-icon" icon={faCut} />
          <span className="page-title">Services</span>
        </h2>
        {/* End Page Title */}
        {/* Page Content */}
        <CardDeck>
          <Card>
            <Card.Img variant="top" src={womenscutting_image} />
            <Card.Body>
              <Card.Title>Women's Cutting</Card.Title>
              <Card.Text>
                This is a wider card with supporting text below as a natural lead-in to
                additional content. This content is a little bit longer.
              </Card.Text>
            </Card.Body>
          </Card>
          <Card>
            <Card.Img variant="top" src={menscutting_image} />
            <Card.Body>
              <Card.Title>Men's Cutting</Card.Title>
              <Card.Text>
                This card has supporting text below as a natural lead-in to additional
                content.{' '}
              </Card.Text>
            </Card.Body>
          </Card>
          <Card>
            <Card.Img variant="top" src={updostyles_image} />
            <Card.Body>
              <Card.Title>Updo Styles</Card.Title>
              <Card.Text>
                This is a wider card with supporting text below as a natural lead-in to
                additional content. This card has even longer content than the first to
                show that equal height action.
              </Card.Text>
            </Card.Body>
          </Card>
        </CardDeck>
        <CardDeck>
          <Card>
            <Card.Img variant="top" src={styling_image} />
            <Card.Body>
              <Card.Title>Styling</Card.Title>
              <Card.Text>
                This is a wider card with supporting text below as a natural lead-in to
                additional content. This content is a little bit longer.
              </Card.Text>
            </Card.Body>
          </Card>
          <Card>
            <Card.Img variant="top" src={coloring_image} />
            <Card.Body>
              <Card.Title>Coloring/Balayage</Card.Title>
              <Card.Text>
                This card has supporting text below as a natural lead-in to additional
                content.{' '}
              </Card.Text>
            </Card.Body>
          </Card>
          <Card>
            <Card.Img variant="top" src={hairtreatment_image} />
            <Card.Body>
              <Card.Title>Hair Treatment</Card.Title>
              <Card.Text>
                This is a wider card with supporting text below as a natural lead-in to
                additional content. This card has even longer content than the first to
                show that equal height action.
              </Card.Text>
            </Card.Body>
          </Card>
        </CardDeck>
        {/* End Page Content */}
      </Container>
    </div>
  );
};

export default ServicesPage;